import React from "react";
import styled from "styled-components";

import { theme } from "../../theme";

// const Container = styled.div`
//   color: ${props => props.theme.text};
//   display: flex;
//   flex-direction: column;
//   align-items: center;

//   text-align: center;

//   margin: ${props => {
//     if (props.size === "medium") return "0 10px 20px 10px";
//     else if (props.size === "large") return "28px 0 0 28px";
//     else return "0 auto 17px";
//   }};

//   font-size: ${props => {
//     if (props.size === "large") return "12px";
//     else return "9px";
//   }};

//   line-height: ${props => {
//     if (props.size === "large") return "14px";
//     else return "18px";
//   }};

//   @media (min-width: 1800px) {
//     margin: ${props => {
//       if (props.size === "medium") return "0 10px 20px 10px";
//       else if (props.size === "large") return "28px 0 0 28px";
//       else return "0 auto 17px";
//     }};

//     font-size: ${props => {
//       if (props.size === "large") return "18px";
//       else if (props.size === "medium") return "12px";
//       else return "14px";
//     }};

//     line-height: ${props => {
//       if (props.size === "large") return "30px";
//       if (props.size === "medium") return "21px";
//       else return "21px";
//     }};
//   }

//   @media (max-width: 575px) {
//     font-size: ${props => {
//       if (props.size === "large") return "12px";
//       else return "12px";
//     }};
//     margin: ${props => {
//       if (props.size === "medium") return "0 10px 20px 10px";
//       else if (props.size === "large") return "0 15px 0";
//       else return "0 auto 17px";
//     }};
//   }
// `;

const Scale = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 100%;
  height: 100%;
  background-color: ${props =>
    props.secondary ? "rgba(226,106,113,0.5)" : "rgba(46, 112, 116, 0.5)"};
  margin-bottom: 10px;

  /* @media (min-width: 1800px) {
    margin-bottom: 14px;
    width: ${props => {
      if (props.size === "small") return "55px";
      else if (props.size === "large") return "115.06px";
      else return "80px";
    }};
    height: ${props => {
      if (props.size === "small") return "55px";
      else if (props.size === "large") return "115.06px";
      else return "80px";
    }};
  }

  @media (max-width: 575px) {
    width: ${props => {
      if (props.size === "small") return "55px";
      else if (props.size === "large") return "72.48px";
      else return "57px";
    }};
    height: ${props => {
      if (props.size === "small") return "55px";
      else if (props.size === "large") return "72.48px";
      else return "57px";
    }};
  } */
`;

const Fill = styled.div`
  border-radius: 50%;
  background-color: ${props =>
    props.secondary ? theme.nightMode.color7 : theme.nightMode.color3};
  width: ${props => props.value};
  height: ${props => props.value};
`;

const CircleFillGraph = ({
  value,
  title,
  size = "medium",
  showValue = true,
  secondary
}) => {
  return (
    <>
      <Scale secondary={secondary}>
        <Fill value={`${value}%`} secondary={secondary} />
      </Scale>
      {/* <div>{title}</div>
      {showValue && <div> {`${value}%`}</div>} */}
    </>
  );
};

export default CircleFillGraph;
